import { StylesConfig } from "react-select";
import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = (theme) =>
    makeStyles({
        root: {
            display: "flex",
            flexDirection: "column",

            "& .MuiSvgIcon-root": {
                color: theme.select.common.iconColor,
                marginLeft: theme.select.startIcon.offset,
            },
        },
        label: {
            color: theme.select.common.color,
            fontFamily: theme.select.common.fontFamily,
            fontWeight: theme.select.common.fontWeight,
            fontSize: theme.select.common.fontSize,
            marginBottom: theme.select.common.offset,
        },
        asterix: {
            color: theme.select.error.color,
            fontFamily: theme.select.common.fontFamily,
            fontWeight: theme.select.common.fontWeight,
            fontSize: theme.select.common.fontSize,
        },
        error: {
            display: "flex",
            alignItems: "center",
            color: theme.select.error.color,
            fontFamily: theme.select.common.fontFamily,
            fontWeight: theme.select.common.fontWeight,
            fontSize: theme.select.common.fontSize,
            marginTop: theme.select.common.offset,
        },
        errorIcon: {
            color: theme.select.error.color,
            marginRight: theme.select.common.offset,
        },
    })();

export const selectCustomStyles: StylesConfig = ({ hasError = false, theme, hasStartIcon }) => ({
    container: (styles) => ({
        ...styles,
        fontFamily: theme.select.common.fontFamily,
        fontWeight: theme.select.common.fontWeight,
        fontSize: theme.select.common.fontSize,
        color: theme.select.common.color,
        minWidth: "100%",
    }),
    control: (styles, { isFocused }) => ({
        ...styles,
        color: hasError ? theme.select.inputError.color : "inherit",
        backgroundColor: hasError ? theme.select.inputError.backgroundColor : styles.backgroundColor,
        borderColor: hasError ? theme.select.inputError.color : theme.select.common.borderColor,
        borderRadius: theme.select.common.borderRadius,
        height: "40px",
        boxShadow: "unset",

        outline: isFocused ? theme.select.common.focus.outline : "unset",
        outlineOffset: isFocused ? theme.select.common.focus.outlineOffset : "unset",

        ":hover": {
            ...styles[":hover"],
            borderColor: hasError ? theme.select.inputError.borderColor : theme.select.common.borderColor,
        },
    }),
    input: (styles) => ({
        ...styles,
        color: hasError ? theme.select.inputError.color : "inherit",
    }),
    singleValue: (styles) => ({
        ...styles,
        color: hasError ? theme.select.inputError.color : "inherit",
    }),
    placeholder: (styles) => ({
        ...styles,
        color: theme.select.common.placeholderColor,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isDisabled
            ? undefined
            : isSelected
              ? theme.select.option.selectedBackgroundColor
              : isFocused
                ? theme.select.option.focuedBackgroundColor
                : undefined,
        color: theme.select.option.color,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled ? theme.select.option.selectedBackgroundColor : undefined,
        },
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: theme.select.common.iconColor,

        ":hover": {
            ...styles[":hover"],
            color: theme.select.common.iconColor,
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        cursor: "pointer",
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: `2px 8px 2px ${hasStartIcon ? "4px" : "8px"}`,
    }),
});
